import { toast } from "react-toastify";

import { publicDataImportResourceName } from "store/configureResources";
import { modalClose } from "store/modal/actions";

import { createResource } from "store/resources/actions/createResource";

export const uploadPublicDataSnapshot =
    ({ id, idClient, file, onStart, onComplete }: UploadPublicDataSnapshotParams) =>
    // @ts-ignore
    (dispatch) => {
        let formData = new FormData();

        formData.append("id", id);
        formData.append("file", file);

        dispatch(modalClose());

        const onUploadSuccess = () => {
            toast.success("File uploaded successfully.");

            onComplete?.();
        };

        const onUploadError = (action: any) => {
            const message = action?.message?.split("\n", 2)[0];
            const errorMessage = "Public Data upload failed. " + message;

            toast.error(errorMessage);

            onComplete?.();
        };

        dispatch(
            createResource({
                resourceName: publicDataImportResourceName,
                key: id,
                query: {
                    idClient,
                },
                body: formData,
                showSuccessNotification: false,
                showErrorNotification: false,
                onStart,
                onSuccess: onUploadSuccess,
                onError: (action) => {
                    onUploadError(action);
                },
            })
        );
    };

interface UploadPublicDataSnapshotParams {
    /**
     * Upload ID.
     */
    id: string;

    /**
     * ID of Client.
     */
    idClient: number;

    /**
     * Public data.
     */
    file: File;

    /**
     * Function to run when upload has started.
     */
    onStart?: () => void;

    /**
     * Function to run when upload is complete.
     */
    onComplete?: () => void;
}
